package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface M2MEnvironment: Environment {
    val host: String
    val path: String
    val serviceId: String
    val serviceSecret: String
    val apiKey: String
}

@JsExport
abstract class BaseM2MEnvironment(override val path: String = "") : M2MEnvironment

@JsExport
data class DevM2MEnvironment(
    override val host: String = "dev.redwolf.external.plat.vizio.com",
    override val serviceId: String,
    override val serviceSecret: String,
    override val apiKey: String
): BaseM2MEnvironment()

@JsExport
data class StageM2MEnvironment(
    override val host: String = "stage.redwolf.external.plat.vizio.com",
    override val serviceId: String,
    override val serviceSecret: String,
    override val apiKey: String
): BaseM2MEnvironment()

@JsExport
data class PreProdM2MEnvironment(
    override val host: String = "preprod.redwolf.external.plat.vizio.com",
    override val serviceId: String,
    override val serviceSecret: String,
    override val apiKey: String
): BaseM2MEnvironment()

@JsExport
data class ProdM2MEnvironment(
    override val host: String = "prod.redwolf.external.plat.vizio.com",
    override val serviceId: String,
    override val serviceSecret: String,
    override val apiKey: String
): BaseM2MEnvironment()

fun chooseM2MEnvironment(envConfig: M2MEnvironmentConfig): M2MEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdM2MEnvironment(
            serviceId = envConfig.serviceId,
            serviceSecret = envConfig.serviceSecret,
            apiKey = envConfig.apiKey
        )
        EnvironmentGroup.PREPROD -> PreProdM2MEnvironment(
            serviceId = envConfig.serviceId,
            serviceSecret = envConfig.serviceSecret,
            apiKey = envConfig.apiKey
        )
        EnvironmentGroup.STAGE -> StageM2MEnvironment(
            serviceId = envConfig.serviceId,
            serviceSecret = envConfig.serviceSecret,
            apiKey = envConfig.apiKey
        )
        EnvironmentGroup.DEV -> DevM2MEnvironment(
            serviceId = envConfig.serviceId,
            serviceSecret = envConfig.serviceSecret,
            apiKey = envConfig.apiKey
        )
        EnvironmentGroup.TEST -> TODO("TestM2MEnvironment() is not defined")
    }
}